import { ListboxList } from '../listbox/listbox-list.component.js';
var ComboboxList = ListboxList;
export { ComboboxList };